import React from "react";
import { Table, Typography } from "antd";
import { Link } from "react-router-dom";
import { Card } from "./styles";
import { startCase } from "lodash-es";
import * as S from "./styles";
import { InventoryTransferActivity } from "../../../api/transfer";
import moment from "moment";

const { Title } = Typography;

export interface TransferActivityProps {
  loading: boolean;
  orderId: string;
  activities: InventoryTransferActivity[];
}
export const TransferActivity: React.FC<TransferActivityProps> = ({ loading, orderId, activities }) => {
  return (
    <S.Container direction="vertical">
      <Title level={5}>Activity</Title>
      <Card size="small" bordered>
        <Table
          loading={loading}
          columns={[
            {
              title: "Reference ID",
              dataIndex: "id",
              width: "33%",
              render: (id, data) => {
                if (data.type === "outbound") {
                  return <Link to={`/fulfillment/orders/${orderId}/shipment/${id}`}>{data.name}</Link>;
                }
                return <Link to={`/fulfillment/asns/${id}`}>{data.name}</Link>;
              },
            },
            { title: "Type", width: "33%", dataIndex: "type", render: startCase },
            { title: "Date", width: "33%", dataIndex: "created_at", render: (date) => moment(date).format("LLL") },
          ]}
          dataSource={activities || []}
          rowKey={(t) => t.id}
          pagination={false}
        />
      </Card>
    </S.Container>
  );
};
